import { lazy } from 'react'

export const TeachersPage = lazy(() => import('./Teachers'))
export const TeacherAddPage = lazy(() => import('./TeacherAdd'))
export const TeacherEditPage = lazy(() => import('./TeacherEdit'))
